import type { Locale } from 'date-fns';
import { de, enUS, es, fr, pt } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

const localeMap: Record<string, Locale> = {
  en: enUS,
  pt: pt,
  fr: fr,
  es: es,
  de: de
};

export function useDateLocale(): Locale {
  const { i18n } = useTranslation();
  return localeMap[i18n.language] || enUS;
}
